import { render, staticRenderFns } from "./AmountInputConfig.vue?vue&type=template&id=23213d2c&scoped=true"
import script from "./AmountInputConfig.vue?vue&type=script&lang=js"
export * from "./AmountInputConfig.vue?vue&type=script&lang=js"
import style0 from "./AmountInputConfig.vue?vue&type=style&index=0&id=23213d2c&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23213d2c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/jenkins_home/workspace/Test-OA/jh-oa-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('23213d2c')) {
      api.createRecord('23213d2c', component.options)
    } else {
      api.reload('23213d2c', component.options)
    }
    module.hot.accept("./AmountInputConfig.vue?vue&type=template&id=23213d2c&scoped=true", function () {
      api.rerender('23213d2c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/officeApproval/common/form/config/AmountInputConfig.vue"
export default component.exports